/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetBotStrategiesStatus200,
  GetBotStrategiesStatus500,
} from '../types/GetBotStrategies'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getBotStrategies } from '../clients/getBotStrategies'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getBotStrategiesQueryKey = () => [{ url: '/v1/bot/strategies' }] as const

type GetBotStrategiesQueryKey = ReturnType<typeof getBotStrategiesQueryKey>

export function getBotStrategiesQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getBotStrategiesQueryKey()
  return queryOptions<
    GetBotStrategiesStatus200,
    ResponseErrorConfig<GetBotStrategiesStatus500>,
    GetBotStrategiesStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getBotStrategies({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Get a list of all bot strategies. Admin-only.
 * @summary Get all bot strategies
 * {@link /v1/bot/strategies}
 */
export function useGetBotStrategies<
  TData = GetBotStrategiesStatus200,
  TQueryData = GetBotStrategiesStatus200,
  TQueryKey extends QueryKey = GetBotStrategiesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetBotStrategiesStatus200,
        ResponseErrorConfig<GetBotStrategiesStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getBotStrategiesQueryKey()

  const queryResult = useQuery(
    {
      ...getBotStrategiesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetBotStrategiesStatus500>> & {
    queryKey: TQueryKey
  }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
